import { NgModule } from '@angular/core';
import { FeedbackCmsComponents } from '@core/const';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        feedback: {
          module: () => import('./sdvor-feedback-lazy.module').then((m) => m.FeedbackLazyModule),
          cmsComponents: Object.values(FeedbackCmsComponents),
        },
      },
    }),
  ],
})
export class SdvorFeedbackShellModule {}
